import { useLayoutEffect, useState } from 'react';

/**
 * The rendered height of an element, followed as its content changes, so a
 * wrapper can transition between heights (CSS cannot animate to `auto`).
 *
 * Returns a callback ref and the height in px. The height is undefined until
 * the first measurement, and stays undefined where ResizeObserver does not
 * exist (jsdom), so the wrapper falls back to its natural height there.
 */
export const useContentHeight = (): [(node: HTMLElement | null) => void, number | undefined] => {
  const [node, setNode] = useState<HTMLElement | null>(null);
  const [height, setHeight] = useState<number | undefined>(undefined);

  useLayoutEffect(() => {
    if (!node || typeof ResizeObserver === 'undefined') return;
    const observer = new ResizeObserver(() => setHeight(node.offsetHeight));
    observer.observe(node);
    return () => observer.disconnect();
  }, [node]);

  return [setNode, height];
};
